import axios from '@/_utils/axios';
import OverflowMenuItem from '@/components/_common/OverflowMenu/OverflowMenuItem';
import { useToast } from '@/components/_common/Toast';
import { OverflowMenu, PolarisIcon } from '@/exports/columnCommonComponents';
import { useAppDispatch } from '@/redux/hooks';
import { getData } from '@/redux/slices/dataTableSlice';
import { FocusVersionScheduling } from '@/redux/slices/slice_types';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import EditIncrementalLaunchModal from './IncrementalLaunchModal/EditIncrementalLaunchModal';
import { LaunchModalMode } from '@/components/Focus/AvailsSchedule/IncrementalLaunchModal/types';
import { ActionDialog } from '../ActionDialog';

type AvailScheduleOverflowActionsProps = {
  row: FocusVersionScheduling;
};

const AvailScheduleOverflowActions = ({ row }: AvailScheduleOverflowActionsProps) => {
  const history = useHistory();
  const { success, info } = useToast();
  const dispatch = useAppDispatch();
  const [isEditIncrementalLaunchModalOpen, setIsEditIncrementalLaunchModalOpen] = useState(false);
  const [isTakedownDialogOpen, setIsTakedownDialogOpen] = useState(false);
  const [editIncrementalLaunchMode, setEditIncrementalLaunchMode] = useState<LaunchModalMode>(LaunchModalMode.Add);

  const handleDelete = () => {
    info(`Deleting version scheduling ${row.id}`);
    axios
      .delete(`focus/scheduling/${row.id}/`, { baseURL: '/api/v1.1' })
      .then(() => {
        success('Version scheduling deleted successfully');
        dispatch(getData());
      })
      .catch(() => {
        success('Scheduling deleted successfully');
        dispatch(getData());
      });
  };

  const handleAddIncrementalLaunchButtonClick = () => {
    setEditIncrementalLaunchMode(LaunchModalMode.Add);
    setIsEditIncrementalLaunchModalOpen(true);
  };

  const handleSubtractIncrementalLaunchButtonClick = () => {
    setEditIncrementalLaunchMode(LaunchModalMode.Remove);
    setIsEditIncrementalLaunchModalOpen(true);
  };

  const handleConfirmTakedown = () => {
    info(`Taking down schedule ${row.id}`);
    setIsTakedownDialogOpen(false);
  };

  return (
    <>
      <OverflowMenu>
        <OverflowMenuItem onClick={handleAddIncrementalLaunchButtonClick}>
          <PolarisIcon icon="add" height={12} />
          Add New Expansion
        </OverflowMenuItem>
        <OverflowMenuItem onClick={handleSubtractIncrementalLaunchButtonClick}>
          <PolarisIcon icon="add" height={12} />
          Add New Takedown
        </OverflowMenuItem>
        {row.status === 'draft' && (
          <OverflowMenuItem
            onClick={() => {
              history.push(`/focus/schedule/${row.id}`);
            }}
          >
            <PolarisIcon icon="external_link" height={12} />
            View Details
          </OverflowMenuItem>
        )}
        {row.status === 'draft' && (
          <OverflowMenuItem onClick={() => handleDelete()}>
            <PolarisIcon icon="delete_outline" height={12} />
            Delete
          </OverflowMenuItem>
        )}
        {/* NATALIA: confirmed" status may change */}
        {row.status === 'confirmed' && (
          <OverflowMenuItem onClick={() => setIsTakedownDialogOpen(true)}>
            <PolarisIcon icon="delete_outline" height={12} />
            Takedown
          </OverflowMenuItem>
        )}
      </OverflowMenu>
      <EditIncrementalLaunchModal
        isOpen={isEditIncrementalLaunchModalOpen}
        versionScheduling={row}
        mode={editIncrementalLaunchMode}
        onClose={() => setIsEditIncrementalLaunchModalOpen(false)}
      />
      <ActionDialog
        open={isTakedownDialogOpen}
        title="Takedown Schedule"
        description="Are you sure you want to takedown this schedule?"
        primaryActionLabel="Takedown"
        onPrimaryAction={handleConfirmTakedown}
        secondaryActionLabel="Cancel"
        onSecondaryAction={() => setIsTakedownDialogOpen(false)}
        onClose={() => setIsTakedownDialogOpen(false)}
      />
    </>
  );
};

export default AvailScheduleOverflowActions;
